module.exports = __webpack_public_path__ + "media/images/icons/dagaanbieding-1587f79adbeb91b2978e30461bab263d.svg";